export default __webpack_public_path__ + "static/media/tutorial-step-0.92564639.png";